<template lang="html">
  <div class="container" id="text-page" data-aos="fade-in" data-aos-duration="1000">
    <h1 class="page-title txt-black">Preguntas Frecuentes</h1>

    <h6>1.-¿Cómo puedo comprar boletos en línea?</h6>
    <p>
      Para comprar boletos en línea, simplemente visite nuestro sitio web. Seleccione su ruta, elija la fecha y hora de su viaje, y siga las instrucciones para completar el pago. Una vez que se confirme su compra, recibirá un correo electrónico con los detalles de su boleto.
    </p>

    <br />
    <h6>2.-¿Qué métodos de pago aceptan para la compra de boletos?</h6>
    <p>
      Aceptamos varias formas de pago, incluyendo tarjetas de crédito y débito, así como otros métodos de pago electrónicos disponibles en nuestra plataforma. Su información de pago está protegida y manejada de manera segura.
    </p>

    <br />
    <h6>3.-¿Puedo cancelar mi boleto y obtener un reembolso?</h6>
    <p>
      Los boletos adquiridos son generalmente no reembolsables. Sin embargo, si su viaje es cancelado por parte de AVIP, será elegible para un reembolso completo. Para consultas sobre reembolsos, comuníquese con nuestro servicio al cliente.
    </p>

    <br />
    <h6>4.-¿Cómo puedo cambiar la fecha o el horario de mi viaje?</h6>
    <p>
      Puede cambiar la fecha o el horario de su viaje contactando a nuestro servicio al cliente, quien le asistirá en el proceso de cambio, sujeto a la disponibilidad y políticas de cambio de AVIP.
    </p>

    <br />
    <h5>5.-¿Qué debo hacer si mi viaje se retrasa?</h5>
    <p>
      En caso de que se produzca un retraso significativo, AVIP se compromete a notificar a los pasajeros a través de los canales de contacto registrados. Si tiene preguntas sobre su viaje, no dude en comunicarte con nuestro servicio al cliente para obtener información actualizada.
    </p>

    <br />
    <h5>6.-¿Cómo puedo contactar a AVIP si tengo más preguntas?</h5>
    <p>
      Puede contactarnos a través de nuestro correo electrónico [Correo Electrónico de Contacto] o llamando a nuestro número de atención al cliente [Número de Teléfono]. Estaremos encantados de ayudarle con cualquier consulta.
    </p>

    <br />
    <h5>7.-¿AVIP realiza viajes fuera de Jalisco y Sinaloa?</h5>
    <p>
      Actualmente, AVIP se especializa en el transporte de personal principalmente entre Jalisco y Sinaloa. Sin embargo, estamos trabajando en expandir nuestras rutas en el futuro, así que manténgase atento a nuestras actualizaciones.
    </p>

    <br />
    <h5>8.-¿Qué medidas de seguridad se están tomando para el transporte de pasajeros?</h5>
    <p>
      La seguridad de nuestros pasajeros es una prioridad. Todos nuestros vehículos están equipados con medidas de seguridad adecuadas y nuestros conductores son capacitados y se adhieren a protocolos de seguridad. Además, realizamos mantenimientos regulares a nuestra flota para garantizar un viaje seguro.
    </p>
  </div>
</template>

<script>
export default {
}
</script>
